import type { RelatedClientRecord } from '@/apps/engagement-letter-database/data/types';
import { ArrowBack as ArrowBackIcon, Groups as GroupsIcon } from '@mui/icons-material';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';


interface HeaderPaneProps {
  record: RelatedClientRecord;
}

const HeaderPane = ({ record }: HeaderPaneProps) => {
  const navigate = useNavigate();

  return (
    <>
      <Stack direction="row" spacing={2} sx={{ mb: 3, alignItems: 'center' }}>
        <Button startIcon={<ArrowBackIcon />} onClick={() => void navigate(-1)}>
          Back
        </Button>
        <Box sx={{ flexGrow: 1 }} />
      </Stack>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <GroupsIcon sx={{ mr: 1, color: 'primary.main' }} />
        <Typography variant="h4">{record.RelatedClientName ?? 'Related Client'}</Typography>
      </Box>
      <Typography variant="body1" color="text.secondary" gutterBottom>
        Related Client Number: {record.RelatedClientNumber}
      </Typography>
    </>
  );
};

export default HeaderPane;